import { useTranslation } from "react-i18next";
import * as Yup from "yup";

import { LayerFormValues, PersonalLayer } from "types/types";
import { useSearchParams } from "react-router-dom";
import { convertStringArrToNumberArr } from "utils/ArrayUtils";
import { mapURLSearchParams } from "utils/SearchParamUtils";
import { useMutation, useQuery, useQueryClient } from "react-query";

export const EMPTY_LAYER: LayerFormValues = {
  id: 0,
  name: "Eigen WMS kaart: Digitaal Hoogtemodel Vlaanderen",
  url: "https://geo.api.vlaanderen.be/DHMV/wms?",
  layerName: "DHMVII_DTM_1m",
  legendUrl:
    "https://geo.api.vlaanderen.be/DHMV/wms?request=GetLegendGraphic&version=1.3.0&format=image%2Fpng&layer=DHMVI_DTM_5m",
};

export const usePersonalLayers = () => {
  async function fetch(): Promise<PersonalLayer[]> {
    const personalLayersString = localStorage.getItem("personalLayers");
    const personalLayers: PersonalLayer[] = personalLayersString
      ? JSON.parse(personalLayersString)
      : [];
    return Promise.resolve(personalLayers);
  }
  return useQuery(["personalLayers"], fetch);
};

export function useAddPersonalLayer() {
  const queryClient = useQueryClient();

  async function post(layerFormValues: LayerFormValues) {
    const personalLayer = formatFormValuesToPersonalLayer(layerFormValues);
    const personalLayersString = localStorage.getItem("personalLayers");
    const personalLayers: PersonalLayer[] = personalLayersString
      ? JSON.parse(personalLayersString)
      : [];
    const newPersonalLayers = [...personalLayers, personalLayer];
    localStorage.setItem("personalLayers", JSON.stringify(newPersonalLayers));
    return Promise.resolve(personalLayer);
  }
  return useMutation(post, {
    onSuccess: () => {
      queryClient.invalidateQueries("personalLayers");
    },
  });
}

export function useDeletePersonalLayer() {
  const queryClient = useQueryClient();

  async function remove(id: number) {
    const personalLayersString = localStorage.getItem("personalLayers");
    const personalLayers: PersonalLayer[] = personalLayersString
      ? JSON.parse(personalLayersString)
      : [];
    const newPersonalLayers = personalLayers.filter((layer) => layer.id !== id);
    localStorage.setItem("personalLayers", JSON.stringify(newPersonalLayers));
    return Promise.resolve();
  }
  return useMutation(remove, {
    onSuccess: () => {
      queryClient.invalidateQueries("personalLayers");
    },
  });
}

function isPersonalLayer(
  layer: LayerFormValues | PersonalLayer
): layer is PersonalLayer {
  return layer.hasOwnProperty("wms");
}

export function useUpdatePersonalLayer() {
  const queryClient = useQueryClient();

  async function put(layerFormValues: LayerFormValues | PersonalLayer) {
    const updatedPersonalLayer = isPersonalLayer(layerFormValues)
      ? layerFormValues
      : formatFormValuesToPersonalLayer(layerFormValues);
    const personalLayersString = localStorage.getItem("personalLayers");
    const personalLayers: PersonalLayer[] = personalLayersString
      ? JSON.parse(personalLayersString)
      : [];
    const newPersonalLayers = personalLayers.map((layer) =>
      layer.id === updatedPersonalLayer.id ? updatedPersonalLayer : layer
    );
    localStorage.setItem("personalLayers", JSON.stringify(newPersonalLayers));
    return Promise.resolve(updatedPersonalLayer);
  }
  return useMutation(put, {
    onSuccess: () => {
      queryClient.invalidateQueries("personalLayers");
    },
  });
}

export function formatPersonalLayerToFormValues(
  personalLayer: PersonalLayer
): LayerFormValues {
  const {
    id,
    name,
    legendUrl,
    wms: { layers, url },
  } = personalLayer;

  return {
    id,
    name,
    legendUrl,
    url,
    layerName: layers,
  };
}

function formatFormValuesToPersonalLayer(
  layerFormValues: LayerFormValues
): PersonalLayer {
  const { id, name, legendUrl, url, layerName } = layerFormValues;
  return {
    id: id === 0 ? Date.now() : id,
    name,
    legendUrl,
    wms: {
      opacity: 0.8,
      styles: "",
      transparent: true,
      format: "image/png",
      tiled: true,
      url,
      layers: layerName,
    },
  };
}

// export function useUpdateMeasureConfigs(
//     uuid: string,
//     isNewMeasureConfig: boolean
//   ) {
//     const queryClient = useQueryClient();
//     const { enqueueSnackbar } = useSnackbar();

//     async function post(measureConfigs: MeasureConf[]) {
//       const serializedMeasureConfigs = serializeMeasureConfigs(measureConfigs);
//       const { data } = await customPost<MeasureConfBackend[]>(
//         `/api/studyareas/${uuid}/measureconfigurations`,
//         serializedMeasureConfigs
//       );
//       return deserializeMeasureConfigs(data);
//     }
//     return useMutation(["measureConfigurations", "post", uuid], post, {
//       onMutate: async (measureConfigs) => {
//         // If the measure config is new we are using a temp id
//         // We can't optimistically update the cache with a temp id
//         // So we set the cache value with the response
//         if (isNewMeasureConfig) return;

//         await queryClient.cancelQueries(["measureConfigurations", uuid]);
//         const previousMeasureConfigs = queryClient.getQueryData([
//           "measureConfigurations",
//           uuid,
//         ]);
//         queryClient.setQueryData(["measureConfigurations", uuid], measureConfigs);

//         return { previousMeasureConfigs };
//       },
//       onError: (err, measureConfigs, context) => {
//         queryClient.invalidateQueries(["measureConfigurations", uuid]);
//         const errors = deserializeErrors(err);
//         errors.map((er) => {
//           return enqueueSnackbar(er.message, {
//             variant: "error",
//           });
//         });
//       },
//       onSuccess: (measureConfigs: MeasureConf[]) => {
//         // If the measure config is new we are using a temp id
//         // We can't optimistically update the cache with a temp id
//         // So we set the cache value with the response
//         if (isNewMeasureConfig) {
//           queryClient.setQueryData(
//             ["measureConfigurations", uuid],
//             measureConfigs
//           );
//         }
//       },
//     });
//   }

export function blabla() {
  const personalLayersString = localStorage.getItem("personalLayers");
  const personalLayers: LayerFormValues[] = personalLayersString
    ? JSON.parse(personalLayersString)
    : [];

  function addPersonalLayer(layer: LayerFormValues) {
    const newPersonalLayers = [...personalLayers, layer];
    localStorage.setItem("personalLayers", JSON.stringify(newPersonalLayers));
  }

  function updatePersonalLayer(layer: LayerFormValues) {
    const currentLayerIndex = personalLayers.findIndex(
      (personaLayer) => personaLayer.id === layer.id
    );
    const updatedLayer = { ...personalLayers[currentLayerIndex], ...layer };
    const updatedLayers = [
      ...personalLayers.slice(0, currentLayerIndex),
      updatedLayer,
      ...personalLayers.slice(currentLayerIndex + 1),
    ];
    localStorage.setItem("personalLayers", JSON.stringify([...updatedLayers]));
  }

  function removePersonalLayer(layerId: number) {
    const newPersonalLayers = personalLayers.filter(
      (layer: LayerFormValues) => layer.id !== layerId
    );
    localStorage.setItem("personalLayers", JSON.stringify(newPersonalLayers));
  }

  return {
    personalLayers,
    addPersonalLayer,
    removePersonalLayer,
    updatePersonalLayer,
  };
}

export function useSelectedPersonalLayers() {
  const { data: personalLayers } = usePersonalLayers();
  const { selectedPersonalLayerIds } = usePersonalLayerParams();

  const selectedPersonalLayers = (personalLayers || []).filter((layer) =>
    selectedPersonalLayerIds.includes(layer.id)
  );

  return selectedPersonalLayers;
}

export const useLayerValidation = () => {
  const { t } = useTranslation();

  return Yup.object().shape({
    name: Yup.string().required(
      t("validation.requiredField", { field: t("label.mapName") })
    ),
    url: Yup.string().required(
      t("validation.requiredField", { field: t("label.wmsUrl") })
    ),
    layerName: Yup.string().required(
      t("validation.requiredField", { field: t("label.wmsLayerName") })
    ),
  });
};

export function usePersonalLayerParams() {
  const [params, setParams] = useSearchParams();
  const selectedPersonalLayerIds = convertStringArrToNumberArr(
    params.getAll("pl")
  );

  function updatePersonalLayerParams(layerId: number, checked: boolean) {
    const newParams = checked
      ? new URLSearchParams(params)
      : mapURLSearchParams(params, ["pl"]);

    if (checked) {
      newParams.append("pl", layerId.toString());
    }

    if (!checked) {
      const filteredLayerIds = selectedPersonalLayerIds.filter(
        (value) => value !== layerId
      );
      filteredLayerIds.forEach((id) => newParams.append("pl", id.toString()));
    }

    setParams(newParams);
  }

  function removePersonalLayerParams(layerId: number) {
    const newParams = mapURLSearchParams(params, ["pl"]);
    const filteredLayerIds = selectedPersonalLayerIds.filter(
      (value) => value !== layerId
    );
    filteredLayerIds.forEach((id) => newParams.append("pl", id.toString()));
    setParams(newParams);
  }

  return {
    selectedPersonalLayerIds,
    updatePersonalLayerParams,
    removePersonalLayerParams,
  };
}
